"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_auth_1 = require("@hiver/analytics-auth");
var hiver_config_library_1 = require("@hiver/hiver-config-library");
var throttle_1 = __importDefault(require("lodash/throttle"));
var http = function (request) {
    return new Promise(function (resolve, reject) {
        var response;
        fetch(request)
            .then(function (res) {
            response = res;
            return res.json();
        })
            .then(function (body) {
            if (response.ok) {
                response.parsedBody = body;
                resolve(response);
            }
            else {
                reject(response);
            }
        })
            .catch(function (err) {
            reject(err);
        });
    });
};
var getAuthToken = throttle_1.default(function (authToken) { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(authToken === hiver_config_library_1.getConfigKey("analytics_token"))) return [3, 2];
                return [4, analytics_auth_1.getAndStoreAnalyticsAuthToken()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2];
        }
    });
}); }, 1000);
exports.A_GET = function (path, headers, retry) {
    if (retry === void 0) { retry = false; }
    return __awaiter(_this, void 0, void 0, function () {
        var authToken, fetchArgs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authToken = hiver_config_library_1.getConfigKey("analytics_token");
                    fetchArgs = {
                        headers: new Headers(__assign({}, (headers || {}), { Authorization: "Bearer " + authToken })),
                        method: "get"
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    if (!authToken || authToken === "null") {
                        throw new Error("authtoken-null");
                    }
                    return [4, http(new Request(path, fetchArgs))];
                case 2: return [2, _a.sent()];
                case 3:
                    err_1 = _a.sent();
                    if (retry) {
                        throw err_1;
                    }
                    if (!(err_1 && (err_1.status === 401 || err_1.message === "authtoken-null"))) return [3, 5];
                    return [4, getAuthToken(authToken)];
                case 4:
                    _a.sent();
                    return [2, exports.A_GET(path, headers, true)];
                case 5: throw err_1;
                case 6: return [2];
            }
        });
    });
};
exports.A_DELETE = function (path, headers, retry) {
    if (retry === void 0) { retry = false; }
    return __awaiter(_this, void 0, void 0, function () {
        var authToken, fetchArgs, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authToken = hiver_config_library_1.getConfigKey("analytics_token");
                    fetchArgs = {
                        headers: new Headers(__assign({}, (headers || {}), { Authorization: "Bearer " + authToken })),
                        method: "delete"
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    if (!authToken || authToken === "null") {
                        throw new Error("authtoken-null");
                    }
                    return [4, http(new Request(path, fetchArgs))];
                case 2: return [2, _a.sent()];
                case 3:
                    err_2 = _a.sent();
                    if (retry) {
                        throw err_2;
                    }
                    if (!(err_2 && (err_2.status === 401 || err_2.message === "authtoken-null"))) return [3, 5];
                    return [4, getAuthToken(authToken)];
                case 4:
                    _a.sent();
                    return [2, exports.A_DELETE(path, headers, true)];
                case 5: throw err_2;
                case 6: return [2];
            }
        });
    });
};
exports.A_POST = function (path, body, headers, args, retry) {
    if (retry === void 0) { retry = false; }
    return __awaiter(_this, void 0, void 0, function () {
        var authToken, fetchArgs, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authToken = hiver_config_library_1.getConfigKey("analytics_token");
                    fetchArgs = __assign({
                        body: body,
                        headers: new Headers(__assign({}, (headers || {}), { Authorization: "Bearer " + authToken })),
                        method: "post"
                    }, (args || {}));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    if (!authToken || authToken === "null") {
                        throw new Error("authtoken-null");
                    }
                    return [4, http(new Request(path, fetchArgs))];
                case 2: return [2, _a.sent()];
                case 3:
                    err_3 = _a.sent();
                    if (retry) {
                        throw err_3;
                    }
                    if (!(err_3 && (err_3.status === 401 || err_3.message === "authtoken-null"))) return [3, 5];
                    return [4, getAuthToken(authToken)];
                case 4:
                    _a.sent();
                    return [2, exports.A_POST(path, body, headers, args, true)];
                case 5: throw err_3;
                case 6: return [2];
            }
        });
    });
};
exports.A_PUT = function (path, body, args, headers, retry) {
    if (retry === void 0) { retry = false; }
    return __awaiter(_this, void 0, void 0, function () {
        var authToken, fetchArgs, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authToken = hiver_config_library_1.getConfigKey("analytics_token");
                    fetchArgs = __assign({ body: JSON.stringify(body), headers: new Headers(__assign({}, (headers || {}), { Authorization: "Bearer " + authToken })), method: "put" }, (args || {}));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    if (!authToken || authToken === "null") {
                        throw new Error("authtoken-null");
                    }
                    return [4, http(new Request(path, fetchArgs))];
                case 2: return [2, _a.sent()];
                case 3:
                    err_4 = _a.sent();
                    if (retry) {
                        throw err_4;
                    }
                    if (!(err_4 && (err_4.status === 401 || err_4.message === "authtoken-null"))) return [3, 5];
                    return [4, getAuthToken(authToken)];
                case 4:
                    _a.sent();
                    return [2, exports.A_PUT(path, body, args, headers, true)];
                case 5: throw err_4;
                case 6: return [2];
            }
        });
    });
};
exports.A_PATCH = function (path, body, args, headers, retry) {
    if (retry === void 0) { retry = false; }
    return __awaiter(_this, void 0, void 0, function () {
        var authToken, fetchArgs, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authToken = hiver_config_library_1.getConfigKey("analytics_token");
                    fetchArgs = __assign({ body: JSON.stringify(body), headers: new Headers(__assign({}, (headers || {}), { Authorization: "Bearer " + authToken })), method: "PATCH" }, (args || {}));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    if (!authToken || authToken === "null") {
                        throw new Error("authtoken-null");
                    }
                    return [4, http(new Request(path, fetchArgs))];
                case 2: return [2, _a.sent()];
                case 3:
                    err_5 = _a.sent();
                    if (retry) {
                        throw err_5;
                    }
                    if (!(err_5 && (err_5.status === 401 || err_5.message === "authtoken-null"))) return [3, 5];
                    return [4, getAuthToken(authToken)];
                case 4:
                    _a.sent();
                    return [2, exports.A_PATCH(path, body, args, headers, true)];
                case 5: throw err_5;
                case 6: return [2];
            }
        });
    });
};
//# sourceMappingURL=analyticsFetch.js.map